/**
 * DanPro Theme config (local, offline)
 * No external network requests, no HTML injection
 */
var Currency = {
  rates: { USD: 1, EUR: 1.1, GBP: 1.27, CAD: 0.74, AUD: 0.65 },
  convert: function (amount, from, to) {
    return amount * (this.rates[from] || 1) / (this.rates[to] || 1);
  }
};
